import { IJob, getCurrentUserTeams } from 'wisestep-api';
import { IUserDTO } from 'wisestep-base';

import CareerBuilder from '../../../images/jobBoardsIcons/CareerBuilder.png';
import CWJob from '../../../images/jobBoardsIcons/CWJob.png';
import Dice from '../../../images/jobBoardsIcons/Dice.png';
import MonsterIcon from '../../../images/jobBoardsIcons/Monster.png';
import TechFetchIcon from '../../../images/jobBoardsIcons/TechFetchIcon.jpeg';

export interface IPremiumJobBoard {
  name: string;
  icon?: JSX.Element;
  availableCredits: number;
  usedCredits: number;
  showJobBoard: boolean;
  jobBoardType: 'US' | 'UK';
}

export const checkPermissionForJobAdminTeamOrCreatedUser = async (
  job: IJob,
  loggedInUser: IUserDTO
) => {
  if (job.id) {
    let emails: string[] = loggedInUser?.email ? [loggedInUser.email] : [];
    if (Array.isArray(loggedInUser.oldEmails) && loggedInUser.oldEmails) {
      emails = [...emails, ...loggedInUser.oldEmails];
    }
    const teamReq = await getCurrentUserTeams();
    const currentUserTeamIds = teamReq.data?.belongsToTeams;
    if (currentUserTeamIds.includes(job.team?.id)) {
      return true;
    }
    if (job.createdBy && emails.indexOf(job.createdBy) > -1) {
      return true;
    }
  }
  return false;
};

export const jobBoardsListUS: IPremiumJobBoard[] = [
  {
    name: 'Dice',
    icon: <img src={Dice} alt="Dice" height={25} width={26} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'US',
  },
  {
    name: 'TechFetch',
    icon: <img src={TechFetchIcon} alt="Tech Fetch Icon" height={30} width={28} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'US',
  },
  {
    name: 'Monster',
    icon: <img src={MonsterIcon} alt="Monster Icon" height={30} width={28} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'US',
  },
  {
    name: 'Career Builder',
    icon: <img src={CareerBuilder} alt="Career Builder" height={30} width={28} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'US',
  },
  {
    name: 'CWJobs',
    icon: <img src={CWJob} alt="CWJobsIcon" height={28} width={28} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'UK',
  },
  {
    name: 'Monster UK',
    icon: <img src={MonsterIcon} alt="Monster Icon" height={30} width={28} />,
    availableCredits: 0,
    usedCredits: 0,
    showJobBoard: false,
    jobBoardType: 'UK',
  },
];
